import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { FaShieldAlt, FaPlus, FaInfoCircle, FaEdit, FaTrash } from "react-icons/fa";
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { Tooltip } from 'react-tooltip';
import { ToastContainer, toast } from 'react-toastify';
import AddAddress from '../../components/AddAddress/AddAddress';
import { useFormik } from 'formik';
import { couponCodeSchema } from '../../schemas';
import { getAddressList, postCheckout, getCoupon, getCartLogin, postCartWithoutLogin, RemoveCart, postStoreCart, postPaymentInit, postPaymentVerify } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';
import { useCartWishlist } from '../CartWishlistContext';
import { FaLock } from "react-icons/fa6";

const Checkout = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [addressList, setAddressList] = useState([]);
    const [selectAddress, setSelectAddress] = useState([]);
    const [selectAddressInd, setSelectAddressInd] = useState(null);
    const [isselectdAddress, setselectdAddress] = useState(false);
    const [data, setData] = useState([]);
    const [coupon, setCoupon] = useState([]);
    const [codes, setCodes] = useState('');
    const [crtData, setCrtData] = useState([]);
    const [cartQuantities, setCartQuantities] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [ismsg, setisMsg] = useState(false);
    const [editAddress, setEditAddress] = useState(null);
    const navigate = useNavigate();
    const { isCart, setIsCart, } = useCartWishlist();

    const initialValues = {
        code: '',
    }

    useEffect(() => {
        if (!localStorage.getItem('userToken')) {
            navigate("/");
        }
    }, [navigate]);


    const updateLoginCartAPI = async () => {
        setLoadings(true);
        try {
            const res = await getCartLogin();
            setCrtData(res.data.data);
            if (isselectdAddress) {
                let postdata = {
                    "billing_id": selectAddress.id,
                }
                updateCheckouts(postdata);
            }
            else {
                let postdata = {
                    "billing_id": '',
                }
                updateCheckouts(postdata);
            }
        } catch (error) {
            setLoadings(false);
        }
    };

    const updatepostCartWithoutLogin = async (sunmitData) => {
        setLoadings(true);
        try {
            const res = await postCartWithoutLogin(sunmitData);
            setCrtData(res.data.data);
            //toast.success('Cart Updated Successfully');
            let postdata;

            if (localStorage.getItem('BuyNowData')) {
                if (isselectdAddress) {
                    postdata = {
                        "sku_id": sunmitData[0].sku_id,
                        "sku_qty": sunmitData[0].quantity,
                        "billing_id": selectAddress.id,
                        "code": codes,
                    }
                }
                else {
                    postdata = {
                        "sku_id": sunmitData[0].sku_id,
                        "sku_qty": sunmitData[0].quantity,
                        "billing_id": '',
                        "code": codes,
                    }
                }
                updateCheckouts(postdata);
            }
            else {
                if (isselectdAddress) {
                    postdata = {
                        "billing_id": selectAddress.id,
                    }

                    updateCheckouts(postdata);
                }
                else {
                    postdata = {
                        "billing_id": '',
                    }
                    updateCheckouts(postdata);
                }
            }

        } catch (error) {
            setLoadings(false);
        }
    };

    const postCartData = async (postdata) => {
        try {
            const res = await postStoreCart(postdata);

            localStorage.setItem("cart", JSON.stringify(res.data.data));

            let inputArray = res.data.data;
            const transformedObject = inputArray.reduce((acc, item) => {
                acc[item.sku_id] = item.quantity;
                return acc;
            }, {});

            setCartQuantities(transformedObject);

            //toast.success(res.data.message);
            updateLoginCartAPI();

        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message);
            setLoadings(false);
        }
    };

    const removeCartData = async (id) => {
        try {
            const res = await RemoveCart(id);
            //toast.success(res.data.message);
            updateLoginCartAPI();
        } catch (error) {
            console.log(error);
        }
    };

    const handleCartUpdate = (updatedCart) => {
        const formattedCart = Object.entries(updatedCart).map(([sku_id, quantity]) => ({
            sku_id: parseInt(sku_id, 10),
            quantity
        }));

        if (localStorage.getItem('BuyNowData')) {
            updatepostCartWithoutLogin(formattedCart);
        }
        else {
            postCartData(formattedCart);
        }
    };

    const handleIncrement = (sku_id, qty) => {
        setLoadings(true);
        if (cartQuantities[sku_id] < qty) {
            const updatedCart = { ...cartQuantities, [sku_id]: (cartQuantities[sku_id] || 1) + 1 };
            setCartQuantities(updatedCart);
            handleCartUpdate(updatedCart);
        }
        else {
            toast.info('Maximum Quantity Reached');
            setLoadings(false);
        }

    };

    const handleDecrement = (sku_id) => {
        setLoadings(true);
        if (cartQuantities[sku_id] === 1) {
            toast.info("Minimum Quantity Reached");
            setLoadings(false);
        }
        else {
            const updatedCart = { ...cartQuantities, [sku_id]: cartQuantities[sku_id] - 1 };
            setCartQuantities(updatedCart);
            handleCartUpdate(updatedCart);
        }
    };

    const handleChanges = (e, sku_id) => {
        const value = parseInt(e.target.value, 10);
        const updatedCart = { ...cartQuantities, [sku_id]: isNaN(value) || value < 1 ? 1 : value };
        setCartQuantities(updatedCart);
        handleCartUpdate(updatedCart);
    };

    const initializeQuantities = (items) => {
        const initialQuantities = {};
        items.forEach(item => {
            initialQuantities[item.sku_id] = item.cart_quantity || 1;
        });
        setCartQuantities(initialQuantities);

        //handleCartUpdate(initialQuantities);
    };

    const handleRemove = (sku_id) => {
        const updatedCart = { ...cartQuantities };
        delete updatedCart[sku_id];

        setCartQuantities(updatedCart);

        // Convert cartQuantities to the required format
        const formattedCart = Object.entries(updatedCart).map(([sku, quantity]) => ({
            sku_id: parseInt(sku, 10),
            quantity
        }));

        localStorage.setItem("cart", JSON.stringify(formattedCart));
        setCrtData(crtData.filter(item => item.sku_id !== sku_id));
        removeCartData(sku_id);
    };

    const getLoginCart = async () => {
        try {
            const res = await getCartLogin();
            setCrtData(res.data.data);
            initializeQuantities(res.data.data);
        } catch (error) {
            setLoading(false);
            localStorage.removeItem('cart');
        }
    };

    const updateCheckouts = async (postdata) => {
        try {
            const res = await postCheckout(postdata);
            setData(res.data.data);
            setLoadings(false);

            if (res?.data?.data?.discount_data.title) {
                setCodes(postdata?.code);
                setFieldValue('code', res.data?.data?.discount_data.code);
            }
            else {
                setCodes('');
                setFieldValue('code', '');
            }

            if (res.data?.data?.error_message) {
                toast.error(res.data.data.error_message);
            }
        } catch (error) {
            setLoadings(false);
            toast.error(error.response.data.message);
        }
    };

    const postCheckouts = async (postdata) => {
        try {
            const res = await postCheckout(postdata);
            setData(res.data.data);

            setLoading(false);
        } catch (error) {
            setLoading(false);
            setisMsg(true);
            if (error.response.data.message == 'Cart is empty.') {
                localStorage.removeItem('cart');
            }
            toast.error(error?.response?.data.message);
        }
    };

    const getAddressId = (addressData) => {

        if (!addressData || addressData.length === 0) {
            return null;
        }

        if (addressData.length === 1) {

            setSelectAddress(addressData[0]);
            setselectdAddress(true);
            setSelectAddressInd(0);
            return addressData[0].id;
        }

        if (addressData.length > 1) {
            const defaultAddress = addressData.find(addr => addr.is_default === 1);

            if (defaultAddress) {
                setSelectAddress(defaultAddress);
                setselectdAddress(true);

                const defaultAddressIndex = addressData.findIndex(addr => addr.is_default === 1);
                const indexToUse = defaultAddressIndex !== -1 ? defaultAddressIndex : 0;
                setSelectAddressInd(indexToUse);

                return defaultAddress.id;
            }
            return '';
        }
    };

    const getAddressLists = async () => {
        try {
            const res = await getAddressList();
            setAddressList(res.data.data);

            const selectedAddressId = getAddressId(res.data.data);

            let postdata;

            if (localStorage.getItem('BuyNowData')) {
                const buyPostData = JSON.parse(localStorage.getItem('BuyNowData'));
                postdata = {
                    "sku_id": buyPostData.sku_id,
                    "sku_qty": buyPostData.quantity,
                    "billing_id": selectedAddressId,
                }
            }
            else {
                postdata = {
                    "billing_id": selectedAddressId,
                }
            }
            postCheckouts(postdata);

        } catch (error) {
            let postdata = {
                "billing_id": '',
            }
            postCheckouts(postdata);
        }
    };

    const getCoupons = async () => {
        setLoading(true);
        try {
            const res = await getCoupon();
            setCoupon(res.data.data);
        } catch (error) {
            setLoading(false);
        }
    };

    const postCartWithoutLogins = async (postData) => {
        try {
            const res = await postCartWithoutLogin([postData]);
            setCrtData(res.data.data);
            initializeQuantities(res.data.data);
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        setLoading(true);
        getCoupons();

        if (localStorage.getItem('BuyNowData')) {
            const postData = JSON.parse(localStorage.getItem('BuyNowData'));
            postCartWithoutLogins(postData);
            getAddressLists();
        }
        else {
            getLoginCart();
            getAddressLists();
        }

    }, [])

    const hendelCancel = () => {
        setIsVisible(false);
    };

    const handleSelectAddress = (item, index) => {
        setLoadings(true);
        let postdata;
        if (localStorage.getItem('BuyNowData')) {
            const buypostData = JSON.parse(localStorage.getItem('BuyNowData'));
            const formattedCart = Object.entries(cartQuantities).map(([sku_id, quantity]) => ({
                sku_id: parseInt(sku_id, 10),
                quantity
            }));
            postdata = {
                "sku_id": formattedCart[0] ? formattedCart[0].sku_id : buypostData.sku_id,
                "sku_qty": formattedCart[0] ? formattedCart[0].quantity : buypostData.quantity,
                "billing_id": item.id,
                "code": codes,
            }
        }
        else {
            postdata = {
                "billing_id": item.id,
                "code": codes,
            }
        }
        updateCheckouts(postdata);
        setSelectAddress(item);
        setselectdAddress(true);
        setSelectAddressInd(index);
    };

    const handlePlaceorder = async () => {
        setLoadings(true);

        let postdata;
        if (localStorage.getItem('BuyNowData')) {
            const buypostData = JSON.parse(localStorage.getItem('BuyNowData'));
            const formattedCart = Object.entries(cartQuantities).map(([sku_id, quantity]) => ({
                sku_id: parseInt(sku_id, 10),
                quantity
            }));
            postdata = {
                "sku_id": formattedCart[0] ? formattedCart[0].sku_id : buypostData.sku_id,
                "sku_quantity": formattedCart[0] ? formattedCart[0].quantity : buypostData.quantity,
                "billing_id": selectAddress.id,
                "order_type": 'online',
                "code": codes,
            }
        }
        else {
            postdata = {
                "billing_id": selectAddress.id,
                "order_type": 'online',
                "code": codes,
            }
        }

        try {
            const res = await postPaymentInit(postdata);

            if (res.data.data) {
                let ops = res.data.data.options;
                const option = {
                    ...ops,  // Spread the ops object correctly
                    modal: {
                        ondismiss: async function () {
                            const payFdata = {
                                "razorpay_order_id": ops.order_id,
                                "transaction_id": res.data.data.transaction_id,
                                "status": "failed"
                            }
                            localStorage.setItem('payDataPayLoad', JSON.stringify(payFdata));
                            setTimeout(() => navigate('/payment-status'), 1000);
                        }
                    },
                    handler: async function (response) {
                        if (response) {
                            let resp = response;
                            const paydata = {
                                ...resp,
                                "transaction_id": res.data.data.transaction_id,
                                "status": "success" //success or failed
                            }
                            localStorage.setItem('payDataPayLoad', JSON.stringify(paydata));
                            setTimeout(() => navigate('/payment-status'), 1000);
                        }
                    }
                };

                const razor = new window.Razorpay(option);
                razor.open();
            }


            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            console.error("Payment Error:", error);
            toast.error(error.response?.data?.message || "Something went wrong");
        }
    };

    const handleClose = () => {
        setModalShow(false);
    };

    const handleCouponsCode = (data) => {
        setLoadings(true);
        let postdata;

        if (localStorage.getItem('BuyNowData')) {
            const buypostData = JSON.parse(localStorage.getItem('BuyNowData'));
            const formattedCart = Object.entries(cartQuantities).map(([sku_id, quantity]) => ({
                sku_id: parseInt(sku_id, 10),
                quantity
            }));
            postdata = {
                "sku_id": formattedCart[0] ? formattedCart[0].sku_id : buypostData.sku_id,
                "sku_qty": formattedCart[0] ? formattedCart[0].quantity : buypostData.quantity,
                "billing_id": selectAddress.id,
                "code": data,
            }

            updateCheckouts(postdata);
        }
        else {

            if (isselectdAddress) {
                postdata = {
                    "billing_id": selectAddress.id,
                    "code": data,
                }
                updateCheckouts(postdata);
            }
            else {
                postdata = {
                    "billing_id": '',
                    "code": data,
                }
                updateCheckouts(postdata);
            }
        }



    };

    const { values, errors, touched, handleBlur, handleChange, setFieldValue, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: couponCodeSchema,
        onSubmit: (values) => {
            handleCouponsCode(values.code);
        }
    })

    return (
        <>
            <Header CartTot={crtData.length} toast={toast} />
            <ToastContainer />
            {isLoading ? (<Loader />) : (
                <>
                    {ismsg ? (
                        <div className='nodata'>
                            <h2>Cart is Empty</h2>
                            <div className='buttonbox'>
                                <Link className='btn btn-green' to={'/product'}>Back to shopping</Link>
                            </div>
                        </div>
                    ) : (
                        <>
                            <header className="site-header" id='Checkoutpage'>
                                <Container>
                                    <div className="header-inner">
                                        <div className="hero-title">
                                            <span className="hero-icon"><FaLock style={{ color: '#00a99d' }} /></span>
                                            <div>
                                                <h1>Checkout</h1>
                                                <p>Complete your order and enjoy premium protection.</p>
                                            </div>
                                        </div>

                                        <nav className="stepper" aria-label="Checkout progress">
                                            <div className="step active">
                                                <div className="step-circle">1</div>
                                                <div className="step-label">Shipping</div>
                                            </div>
                                            <div className="connector done"></div>
                                            <div className={isselectdAddress ? "step active" : "step"}>
                                                <div className="step-circle">2</div>
                                                <div className="step-label">Payment</div>
                                            </div>
                                            <div className={isselectdAddress ? "connector done" : "connector"}></div>
                                            <div className="step">
                                                <div className="step-circle">3</div>
                                                <div className="step-label">Review</div>
                                            </div>
                                        </nav>
                                    </div>
                                </Container>
                            </header>

                            <div id="checkout" className="page-wrap">
                                <div className='checkout-block'>
                                    <Container>
                                        <div className='checkout-box'>
                                            <Row>
                                                <Col md={8}>
                                                    <section className="cardss">
                                                        <div className="cardss-head">
                                                            <h2 className="cardss-title"><span className="step-badge">1</span> Shipping Address</h2>
                                                            <div className="addaress_btn">
                                                                <button className='btn btn-link' onClick={() => setIsVisible(!isVisible)}><FaPlus />Add New</button>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {isVisible ?
                                                                <div className='cards'>
                                                                    <AddAddress
                                                                        toast={toast}
                                                                        hendelCancel={hendelCancel}
                                                                        getAddressLists={getAddressLists}
                                                                        isDefault={true}
                                                                        editAddress={editAddress}
                                                                    />
                                                                </div> : null
                                                            }
                                                            {isselectdAddress ? (
                                                                <div className='cardselected'>
                                                                    {selectAddress && (
                                                                        <>
                                                                            <div className="addressnames">
                                                                                <h6>{`${selectAddress.first_name} ${selectAddress.last_name}`}&nbsp;&nbsp;&nbsp;{selectAddress.mobile_no}</h6>
                                                                                <p>{`${selectAddress.address_line1} ${selectAddress.address_line2} ${selectAddress.landmark} ${selectAddress.city}, ${selectAddress.state.name}`} <b> - {selectAddress.postal_code}</b>
                                                                                </p>
                                                                            </div>
                                                                            <button className="btn btn-border" onClick={() => { setselectdAddress(false); setSelectAddressInd(null); }}>Change</button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className='cardbody'>
                                                                    {isLoading ? <Loader /> : (<>
                                                                        {addressList.map((item, index) => (
                                                                            <div key={`address_${item.id}`} className={index === selectAddressInd ? 'addlistsards active' : 'addlistsards'}>
                                                                                <div className='addresListcontent'>
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="address"
                                                                                        value={item.id}
                                                                                        onChange={() => { setSelectAddress(item); setSelectAddressInd(index); handleSelectAddress(item, index); }}
                                                                                    />
                                                                                    <div className="addressnames">
                                                                                        <h6>{`${item.first_name} ${item.last_name}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {item.mobile_no}</h6>
                                                                                        <p>{`${item.address_line1} ${item.address_line2} ${item.landmark} ${item.city}, ${item.state.name}`}
                                                                                            <b> - {item.postal_code}</b>
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                <button className='btn btn-edit' onClick={() => { setIsVisible(true); setEditAddress(item); }}><FaEdit /></button>
                                                                            </div>
                                                                        ))}

                                                                        {addressList.length == 0 ? (
                                                                            <div className='emptyboxs'>
                                                                                <h4>No Address Found</h4>
                                                                                <button className='btn btn-green' onClick={() => setIsVisible(!isVisible)}><FaPlus /> Add New Address</button>
                                                                            </div>
                                                                        ) : null}
                                                                    </>)}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </section>

                                                    <section id='cartListdata' className="cardss">
                                                        <div className="cardss-head">
                                                            <h2 className="cardss-title"><span className="step-badge">2</span> Order Summary</h2>
                                                            <div className="addaress_btn">
                                                                <button className='btn btn-link' onClick={() => setIsCart(!isCart)}>Edit Cart</button>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {crtData.map((item) => {
                                                                return (
                                                                    <div className="summary-item" key={`cart_${item?.sku_id}`}>

                                                                        <div className="cartimgs">
                                                                            {item?.is_combo == 1 ? <img src={item?.combo_thumbnail} alt='' title='' /> :
                                                                                <img src={item?.media_list[0]?.media_url} alt='' title='' />}
                                                                        </div>
                                                                        <div className="item-info">
                                                                            <div className="item-name">{item?.name}</div>
                                                                            <div className="item-variant">{item?.brands?.name} {item?.model?.name}</div>
                                                                            <div className="item-qty-row">
                                                                                <span className="item-qty">Qty: 1</span>
                                                                                <span className="item-price">₹{item?.price}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </section>
                                                </Col>

                                                <Col md={4}>
                                                    <div className="side-col">
                                                        <section className="cardss">
                                                            <div className="coupon" role="button" tabindex="0" aria-expanded="false">
                                                                <div className='couponhed'>
                                                                    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="#12161C" strokeWidth="1.8"
                                                                        strokeLinecap="round" strokeLinejoin="round">
                                                                        <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z" />
                                                                        <circle cx="7.5" cy="7.5" r="1.3" fill="#12161C" stroke="none" />
                                                                    </svg>
                                                                    <span className="txt">Apply Coupon</span>
                                                                    <span className="chev" aria-hidden="true"></span>
                                                                </div>

                                                                {Array.isArray(data?.popular_category) && (
                                                                    <div className='otherlists'>
                                                                        {coupon.map((item, ind) => (
                                                                            <div key={`cps_${item.id}`}>
                                                                                {item.code == codes ? null : (
                                                                                    <>
                                                                                        {ind <= 2 ? (
                                                                                            <div className='couponslist'>
                                                                                                <div className='content' dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                                                                                <button className='btn btn-link' onClick={() => { handleCouponsCode(item.code); setModalShow(false); }}>Apply</button>
                                                                                            </div>
                                                                                        ) : null}

                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        ))}
                                                                    </div>)}

                                                                <div className='coupons-boxs'>
                                                                    <form id='coupons' onSubmit={handleSubmit} autoComplete="off">
                                                                        <div className='formsboxs'>
                                                                            <div className="field">
                                                                                <input
                                                                                    type="text"
                                                                                    id="code"
                                                                                    name="code"
                                                                                    placeholder='Coupon Code'
                                                                                    autoComplete='off'
                                                                                    value={values.code}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                />

                                                                            </div>
                                                                            <div className='buttonbox'>
                                                                                <button type='submit' className='btn btn-green'>Apply</button>
                                                                            </div>
                                                                        </div>
                                                                        {errors.code && touched.code ? (
                                                                            <p className='errormsg'>{errors.code}</p>
                                                                        ) : null}
                                                                    </form>
                                                                    {coupon.length <= 3 ? null :
                                                                        <button style={{ marginTop: '10px' }} className='btn btn-link' type='button' onClick={() => setModalShow(true)}>View available coupons</button>}
                                                                </div>
                                                            </div>

                                                            <div className="totals">
                                                                <div className="tot-row"><span className="lbl">Subtotal ({data.total_products} items) Subtotal</span><span className="val">₹{data.sub_total}</span></div>
                                                                <div className="tot-row"><span className="lbl">Discount</span><span className="val discount">− ₹{data.discount}</span></div>
                                                                <div className="tot-row"><span className="lbl">Delivery Charges</span><span className="val">₹{data.delivery_charge}</span></div>

                                                                <div className="grand">
                                                                    <span className="lbl">Total</span>
                                                                    <span className="amt">
                                                                        <div className="num">₹{data.grand_total}</div>
                                                                        {/* <div className="save">You Save ₹402 (30%)</div>
                                                        <div className="tax">Inclusive of all taxes</div> */}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            {data?.discount_data?.title ? (
                                                                <div className="save-banner">
                                                                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                                                                        <path d="M4 20 8.5 8l7.5 7.5L4 20z" fill="var(--teal)" />
                                                                        <path d="M13 5.5l1-2M17 8l2.2-1M18 12.5l2 .8M15.5 4.8c.8-.3 1.8.2 1.8 1.2" stroke="var(--teal)"
                                                                            strokeWidth="1.6" strokeLinecap="round" />
                                                                        <circle cx="20" cy="4" r="1" fill="var(--teal)" />
                                                                    </svg>
                                                                    <div>
                                                                        <div className="b-title">{data?.discount_data?.title}</div>
                                                                        <div className="b-sub" dangerouslySetInnerHTML={{ __html: data?.discount_data?.description }}></div>
                                                                    </div>
                                                                </div>
                                                            ) : null}

                                                            {isselectdAddress ?
                                                                <button onClick={() => handlePlaceorder()} className="pay-btn" type="button">
                                                                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none">
                                                                        <rect x="1" y="8" width="16" height="11" rx="2.5" fill="#fff" />
                                                                        <path d="M5 8V5.5a4 4 0 0 1 8 0V8" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
                                                                        <circle cx="9" cy="13.5" r="1.5" fill="var(--teal)" />
                                                                    </svg>
                                                                    Pay ₹{data.grand_total} Securely
                                                                </button> :
                                                                <button disabled className="pay-btn" type="button">
                                                                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none">
                                                                        <rect x="1" y="8" width="16" height="11" rx="2.5" fill="#fff" />
                                                                        <path d="M5 8V5.5a4 4 0 0 1 8 0V8" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
                                                                        <circle cx="9" cy="13.5" r="1.5" fill="var(--teal)" />
                                                                    </svg>
                                                                    Pay ₹{data.grand_total} Securely
                                                                </button>
                                                            }
                                                        </section>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Container>
                                </div>
                            </div>
                        </>
                    )}
                </>
            )
            }

            <Footer toast={toast} />

            <Modal id="cods" show={modalShow} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Grab Your Deal: Limited-Time Coupon Codes!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {coupon.map((item) => (
                        <div className='couponslist' key={`cp_${item.id}`}>
                            <div className='content' dangerouslySetInnerHTML={{ __html: item.description }}></div>
                            <button className='btn btn-link' onClick={() => { handleCouponsCode(item.code); setModalShow(false); }}>Apply</button>
                        </div>
                    ))}
                </Modal.Body>
            </Modal>

            {
                isLoadings ? (
                    <Loader />
                ) : null
            }
        </>
    )
}

export default Checkout;